import { Box, Button, Container, Stack, Typography, styled } from '@mui/material';
import React from 'react';

import { PublicRoutes } from '@/config/routes';

const HeroWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  minHeight: '80vh',
  display: 'flex',
  alignItems: 'center',
  backgroundImage: 'url(/assets/images/aboutus/about-hero-bg.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: theme.palette.common.white,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },
}));

const ContentContainer = styled(Container)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  textAlign: 'center',
  padding: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    maxWidth: '60%',
  },
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif !important',
  fontWeight: 600,
  fontSize: '2.5rem',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    fontSize: '4rem',
  },
}));

const HeroSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  marginBottom: theme.spacing(5),
  maxWidth: '800px',
  margin: '0 auto',
  [theme.breakpoints.up('md')]: {
    fontSize: '1.5rem',
  },
}));

const GetStartedButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: '10px',
  fontWeight: 600,
  fontSize: '1rem',
  padding: '16px 24px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const AboutUsHeroSection: React.FC = () => (
  <HeroWrapper>
    <ContentContainer maxWidth="lg">
      <Stack spacing={4} alignItems="center">
        <HeroTitle>About Terr.ai: Future of Property Management</HeroTitle>

        <HeroSubtitle>
          Revolutionizing property management by leveraging artificial intelligence to streamline
          operations, boost efficiency, and enhance tenant experiences.
        </HeroSubtitle>

        <GetStartedButton variant="contained" size="large" href={PublicRoutes.signup}>
          Get Started
        </GetStartedButton>
      </Stack>
    </ContentContainer>
  </HeroWrapper>
);

export default AboutUsHeroSection;
